module.exports = __webpack_public_path__ + "media/customizations/parkvueontheplatte/logo-new-22907ce457c701769fe26b42948d4aa8.png";